import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import { Checkbox, FormControlLabel, Grid2, IconButton, SpeedDial, SpeedDialAction, useTheme } from '@mui/material';
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import { useContext, useState } from "react";
import LoadingIndicator from '../common/loading.indicator';
import { isCourseActive, lighter } from '../common/util';
import { DialogsContext, SessionDataContext } from '../contexts';
import SubjectAvatar from "../subject/subject.avatar";
import SubjectName from '../subject/subject.name';
import { subjectApi } from "../subject/subject.queries";
import CourseCard from "./course.card";
import { courseApi } from "./course.queries";

export default function CourseList(props) {
	const useGetAll = courseApi.useGetAll();
	let courses = useGetAll?.data;

	const subjectsFetch = subjectApi.useGetAll();
	let subjects = subjectsFetch?.data;

	const { dialogs } = useContext(DialogsContext);
	const sessionData = useContext(SessionDataContext);

	const theme = useTheme();
	const [selectedSubjectId, setSelectedSubjectId] = useState(null);
	const [search, setSearch] = useState('');
	const [hideInactive, setHideInactive] = useState(sessionData.hideInactive);
	
	if (useGetAll.isPending || subjectsFetch.isPending) {
		return <LoadingIndicator />;
	}

	courses = _.orderBy(courses, 'name');
	subjects = _.orderBy(subjects, 'name');
	const selectedSubject = _.find(subjects, {id: selectedSubjectId});

	courses = _.chain(courses)
		.filter(c => !selectedSubject || selectedSubject.id == c.subjectId)
		.filter(c => !search || c.name.toLowerCase().indexOf(search.toLowerCase()) >= 0)
		.sortBy('name').value();

	return (
		<Box sx={{ flex: 1 }}>
			<Stack spacing={0} alignItems="stretch">
				<List dense={true} sx={{ flex: 0, flexShrink: 1, minHeight: 'calc(100vh - 64px)' }}>
					<ListItem onClick={() => setSelectedSubjectId(null)}>
						<Stack direction="column">
							<OutlinedInput sx={{ minWidth: 150 }} startAdornment={
								<InputAdornment position="start">
									<SearchIcon />
								</InputAdornment>
							} defaultValue={search} onChange={(e) => setSearch(e.target.value)} />
							<FormControlLabel sx={{mt:0}} control={<Checkbox checked={hideInactive} onChange={() => { sessionData.set('hideInactive', !hideInactive); setHideInactive(!hideInactive); }} />} label="Hide Inactive?" />
						</Stack>
					</ListItem>
					<ListItemButton onClick={() => setSelectedSubjectId(null)} selected={!selectedSubject}>
						<Typography variant="subtitle1" sx={{ ml: 8, py: 2, fontWeight: 600, fontVariant: 'small-caps' }}>All Subjects</Typography>
					</ListItemButton>
					{subjects.map(subject => (
						<ListItemButton key={subject.id} sx={{ backgroundColor: selectedSubject?.id == subject.id ? lighter(selectedSubject?.colour, 0.6, theme) : '' }} onClick={() => setSelectedSubjectId(subject.id)}>
							<SubjectName subject={subject} size={24} />
						</ListItemButton>
					))}
				</List>
				<Stack direction="column" sx={{ flex: 1, flexGrow: 1, p: 2, backgroundColor: selectedSubject ? lighter(selectedSubject?.colour, 0.6, theme) : theme.palette.action.selected }} alignItems="flex-start">
					{selectedSubject ?
						<Stack alignItems="center" className="hover-toggle">
							<SubjectAvatar subject={selectedSubject} />
							<Typography variant="h4">{selectedSubject.name}</Typography>
							<IconButton className="hover-muted" onClick={() => dialogs.open('subject', selectedSubject)} >
								<EditIcon />
							</IconButton>
						</Stack>
						:
						<Typography variant="h4">All Subjects</Typography>
					}
					<Grid2 container width="100%">
						{courses.map(course => (!hideInactive || isCourseActive(course) ) && (
							<Grid2 size={{ xs: 12, md: 6, lg: 4, xl: 3 }} key={course.id} >
								<CourseCard course={course} showAvatars={true} />
							</Grid2>
						))}
					</Grid2>
					{courses.length == 0 && <Typography variant="h6">No courses added yet.</Typography>}


				</Stack>
			</Stack>

			<SpeedDial sx={{ position: 'fixed', bottom: 10, right: (sessionData.drawerOpen ? 350 : 40), alignItems: 'end', '.MuiSpeedDial-actions': { alignItems: 'end', '.MuiFab-circular': { borderRadius: 2, width: 'auto' } } }} color="primary" icon={<SpeedDialIcon />} ariaLabel="">
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>Add Course</Typography>} onClick={() => dialogs.open('course', { subjectId: selectedSubject?.id, subject: selectedSubject })} />
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>Add Subject</Typography>} onClick={() => dialogs.open('subject', {})} />
			</SpeedDial>
		</Box>
	);
}